import { Box } from "@mui/material";
import StyledButton from "../../../../../product/all-products/components/custom/StyledButton";
import "./index.css";

export const SearchResult = ({ list, handleGetProductDetail, locId, onProductClick }) => {
  return (
    <Box className="prd-search-result-box">
      <p className="search-found-prd">Search Result</p>
      {list?.map((e, idx) => (
        <Box key={idx} className="prd-search-result">
          {/* Clickable product body → opens CartItemDrawer */}
          <Box
            className="prd-search-result-body"
            onClick={() =>
              onProductClick?.({
                gtin: e?.variant?.barcodes?.[0],
                productName: e?.variant?.name || e?.name,
                productImage:
                  e?.variant?.images?.front || e?.images?.front || null,
              })
            }
          >
            {e?.variant?.images?.front ? (
              <img src={e?.variant?.images?.front} alt="product" className="prd-detail-img" />
            ) : (
              <img src={"https://i.imgur.com/dL4ScuP.png"} alt="product" className="prd-detail-img" />
            )}
            <Box>
              <p className="search-result-product-name">{e?.variant?.name || e?.name}</p>
              <p className="search-result-barcode">{e?.variant?.barcodes?.[0]}</p>
            </Box>
          </Box>

          <StyledButton onClick={() => handleGetProductDetail(e?.variant?.barcodes?.[0], locId)}>
            See Details
          </StyledButton>
        </Box>
      ))}
    </Box>
  );
};
